module.exports = __webpack_public_path__ + "img/camera_show.589996bf.svg";